export function round(num: number, dec: number) {
  return (
    Math.round((num + Number.EPSILON) * Math.pow(10, dec)) / Math.pow(10, dec)
  );
}
